<div class="header">
  <p>Nueva contraseña</p>
  <i class="mnf-close fs-18 my-auto cr-pointer" (click)="close()"></i>
</div>

<form [formGroup]="resetPassForm">

  <div class="body">

    <div class="title mb-4">Ingresa tu nueva contraseña</div>

    <!-- CONTRASEÑA -->
    <label class="mnf-control form-password">
      <p class="mnf-control-label">Contraseña</p>

      <input class="mnf-input-form flat" (focusout)="passwordBlur = false" placeholder="•••••••••"
        (focus)="passwordBlur = true" id="reset-password" [type]="passwordFlag" aria-describedby="password"
        formControlName="password" data-bs-toggle="tooltip" trigger="focus" data-bs-placement="right"
        data-bs-html="true" title="<div class='fs-12'>La contraseña debe ser de 8 caracteres y contener al menos:
          <ul class='text-left'>
            <li>1 Letra mayúscula</li>
            <li>1 Letra minúscula</li>
            <li>1 Número</li>
            <li>1 Signo</li>
            <li>No debes tener caracteres idénticos.</li>
            <li>Ni tener 3 caracteres numéricos y/o alfabéticos en forma secuencial.</li>
          </ul>
          *Ejemplo: <strong>qnZrIQt!1</strong></div>" />
      <i class="mnf-show cr-pointer fs-17" *ngIf="passwordFlag === 'password'"
        (click)="passwordFlag = 'text'; passwordBlur = false" style="top: 55%"></i>
      <i class="mnf-hide cr-pointer fs-19" *ngIf="passwordFlag === 'text'"
        (click)="passwordFlag = 'password'; passwordBlur = false" style="top: 54%"></i>
      <div class="error-txt" *ngIf="resetPassForm.controls['password'].invalid">
        <span *ngIf="resetPassForm.controls['password'].invalid && resetPassForm.controls['password'].dirty
               && resetPassForm.controls['password'].touched
               && resetPassForm.controls['password'].value" class="text-red text-right">
          El formato de la contraseña es incorrecto.
        </span>
        <span *ngIf="resetPassForm.controls['password'].touched && !resetPassForm.controls['password'].value"
          class="text-red text-right">
          La contraseña es requerida.
        </span>
      </div>
    </label>

    <!-- CONFIRMAR CONTRASEÑA -->
    <label class="mnf-control form-password">
      <p class="mnf-control-label">Confirmar contraseña</p>

      <input class="mnf-input-form flat" id="confirmPw" type="password" aria-describedby="confirmPassword"
        formControlName="confirmPassword" placeholder="•••••••••" [type]="passwordFlag2" />
      <i class="mnf-show cr-pointer fs-17" *ngIf="passwordFlag2 === 'password'" (click)="passwordFlag2 = 'text'"
        style="top: 55%"></i>
      <i class="mnf-hide cr-pointer fs-19" *ngIf="passwordFlag2 === 'text'" (click)="passwordFlag2 = 'password'"
        style="top: 54%"></i>
      <div class="error-txt">
        <span *ngIf="resetPassForm.errors?.notMatchPass && resetPassForm.controls.password.value
           && resetPassForm.controls.confirmPassword.touched" class="text-red small text-right">
          La contraseñas no coinciden
        </span>
      </div>
    </label>

    <div class="w-100 text-center">
      <button [disabled]="resetPassForm.invalid" mat-button="mat-button" (click)="resetUserPassword()">
        Continuar
      </button>
    </div>
  </div>

</form>
